// extracted by css-extract-rspack-plugin
export default {"timeline":"timeline-Qrh3r2","line":"line-I7t7R3"};